<bp-hl-area-container name="Substrate-Horizonte" [scrollX]="true">
	<div style="display: flex; gap: 0.75rem; align-items: flex-start;">
		<div style="flex: 1 1 auto;">
			<table class="table table-sm table-striped no-bottom-margin">
					<thead>
						<tr><th [attr.colspan]="colSpanSubstrate()">Substratfolge</th></tr>
						<tr>
							<th class="vertical-th" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Zeile dazu</span></th>
							<th class="vertical-th col-tiefe" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Tiefe bis [cm]</span></th>
							<th class="vertical-th col-maechtigkeit" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Mächtigkeit [cm]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></th>
							<th class="vertical-th" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">im Wechsel</span></th>
							<th *ngIf="isM()" class="vertical-th torfart-header" colspan="3">Torfart <wd-help name="TorfMuddeArten"></wd-help></th>
							<th class="vertical-th col-substrat" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Substrat <wd-help *ngIf="isM()" name="Moorsubstrat"></wd-help></span></th>
							<th *ngIf="isM()" class="vertical-th col-narrow" rowspan="2"><span class="vertical">Zersetzungsgrad <wd-help name="Zersetzungsgrad"></wd-help></span></th>
							<th *ngIf="isM()" class="vertical-th col-narrow" rowspan="2"><span class="vertical">Konsistenz <wd-help name="Konsistenz"></wd-help></span></th>
							<th *ngIf="!isM()" class="vertical-th col-narrow"><span class="vertical">Humusgehalt <wd-help name="Humusgehalt"></wd-help></span></th>
							<th *ngIf="!isM()" class="vertical-th col-narrow"><span class="vertical">Lagerungsdichte <wd-help name="Lagerungsdichte"></wd-help></span></th>
							<th class="vertical-th col-narrow" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Skelettgehalt</span></th>
							<th class="vertical-th col-narrow" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Karbonat</span></th>
							<th *ngIf="isM()" class="vertical-th col-narrow" rowspan="2"><span class="vertical">Substanzvolumen <wd-help name="Substanzvolumen"></wd-help></span></th>
							<th *ngIf="isM()" class="vertical-th col-besonderheiten" rowspan="2"><span class="vertical">Besonderheiten</span></th>
							<th *ngIf="!isB()" class="vertical-th col-farbe" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Farbe <wd-help name="Farbe"></wd-help></span></th>
							<th class="vertical-th" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical double-width">nWSK<br/>pro Schicht</span></th>
							<th class="vertical-th" [attr.rowspan]="isM() ? 2 : 1"><span class="vertical">Löschen</span></th>
						</tr>
						<tr *ngIf="isM()">
							<!-- Torfart Unterüberschriften -->
							<th class="vertical-th col-torfart"><span class="vertical">überw.</span></th>
							<th class="vertical-th col-torfart"><span class="vertical">beigem.</span></th>
							<th class="vertical-th col-torfart"><span class="vertical">nachr.</span></th>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let row of data.Substratfolge; let i = index; trackBy: trackByIndex">
							<tr>
								<td><button *ngIf="row.tiefe > 0" type="button" class="btn btn-outline-secondary btn-sm intermediate-plus" (click)="onAddSubstratZeile(i)"><bi name="plus"></bi><bi name="arrow-90deg-right"></bi></button></td>
								<td class="col-tiefe"><wd-number-input name="STiefe[{{i}}]" [(model)]="row.tiefe" [hideComments]="true"></wd-number-input></td>
								<td class="col-maechtigkeit"><wd-number-input name="SMächtigkeit[{{i}}]({{row.tiefe}}cm)" [(model)]="row.maechtigkeit" [hideComments]="true"></wd-number-input></td>
								<td><wd-checkbox-input name="Wechselschichtung[{{i}}]({{row.tiefe}}cm)" [(model)]="row.wechselschichtung" icon="arrow-left-right" [hideComments]="true"></wd-checkbox-input></td>
								<ng-container *ngIf="isM()">
									<td *ngFor="let col of row.torfarten; let j = index; trackBy: trackByIndex">
										<wd-typeahead name="Torfart{{j+1}}[{{i}}]({{row.tiefe}}cm)" [(model)]="row.torfarten[j]" [hideComments]="true"></wd-typeahead>
									</td>
								</ng-container>
								<td class="col-substrat"><wd-typeahead name="Substrat[{{i}}]({{row.tiefe}}cm)" tableName="Bodenarten" [(model)]="row.substrat" placement="right-top" [hideComments]="true"></wd-typeahead></td>
								<td *ngIf="isM()" class="col-narrow"><wd-number-list-input *ngIf="isTorf(row) || isQuellsediment(row)" name="Torf-Zersetzungsgrad[{{i}}]({{row.tiefe}}cm)" [(model)]="row.torfZersetzungsgrad" [hideComments]="true"></wd-number-list-input></td>
								<td *ngIf="isM()" class="col-narrow"><wd-number-list-input *ngIf="isMudde(row) || isQuellsediment(row)" name="Mudde-Konsistenz[{{i}}]({{row.tiefe}}cm)" [(model)]="row.muddeKonsistenz" [hideComments]="true"></wd-number-list-input></td>
								<td *ngIf="!isM()" class="col-narrow"><wd-number-list-input name="Humusgehalt[{{i}}]({{row.tiefe}}cm)" [(model)]="row.humusgehalt" [hideComments]="true"></wd-number-list-input></td>
								<td *ngIf="!isM()" class="col-narrow"><wd-number-list-input name="Lagerungsdichte[{{i}}]({{row.tiefe}}cm)" [(model)]="row.lagerungsdichte" [hideComments]="true"></wd-number-list-input></td>
								<td class="col-narrow"><wd-number-list-input name="Skelettgehalt[{{i}}]({{row.tiefe}}cm)" [(model)]="row.skelettgehalt" [hideComments]="true"></wd-number-list-input></td>
								<td class="col-narrow"><wd-number-list-input name="Karbonat[{{i}}]({{row.tiefe}}cm)" [(model)]="row.karbonatgehalt" [hideComments]="true"></wd-number-list-input></td>
								<td *ngIf="isM()" class="col-narrow"><wd-number-list-input name="Substanzvolumen[{{i}}]({{row.tiefe}}cm)" [(model)]="row.substanzvolumen" [hideComments]="true"></wd-number-list-input></td>
								<td *ngIf="isM()" class="col-besonderheiten"><wd-textarea name="Besonderheiten[{{i}}]({{row.tiefe}}cm)" [(model)]="row.besonderheiten" [hideComments]="true" modalContainerSelector="bp-hl-area-container"></wd-textarea></td>
								<td *ngIf="!isB()" class="col-farbe"><wd-text-input name="Farbe[{{i}}]({{row.tiefe}}cm)" [(model)]="row.farbe" [hideComments]="true"></wd-text-input></td>
								<td style="text-align: right;">{{schichtNWSK(i)}}</td>
								<td><button type="button" class="btn btn-danger btn-sm" (click)="onRemoveSubstratZeile(i)"><bi name="trash"></bi></button></td>
							</tr>
							<tr *ngIf="hasSubstratRowComments(i, row.tiefe)" wd-table-row-comments
								[rowIndex]="i" [tiefe]="row.tiefe" [fieldPrefixes]="substratFieldPrefixes()" [colspan]="colSpanSubstrate()" [fieldNameMap]="fieldNameMap">
							</tr>
						</ng-container>
						<tr>
							<td [attr.colspan]="colSpanSubstrate()">
								<button style="width: 100%" type="button" class="btn btn-info" (click)="onAddSubstratZeile()"><bi name="plus"></bi></button>
							</td>
						</tr>
					</tbody>
				</table>
		</div>
		<div style="flex: 1 1 auto;">
			<table class="table table-sm table-striped no-bottom-margin">
					<thead>
						<tr><th colspan="7">Horizontfolge</th></tr>
						<tr>
							<th class="vertical-th" style="min-width: 2rem; width: 2rem;"><span class="vertical">Zeile dazu</span></th>
							<th class="vertical-th col-tiefe"><span class="vertical">Tiefe bis [cm]</span></th>
							<th class="vertical-th col-maechtigkeit"><span class="vertical">Mächtigkeit [cm]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></th>
							<th class="vertical-th" colspan="3" style="min-width: 12rem;"><span class="">Horizont</span></th>
							<th class="vertical-th" style="min-width: 2rem; width: 2rem;"><span class="vertical">Löschen</span></th>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let row of data.Horizontfolge; let i = index; trackBy: trackByIndex">
							<tr>
								<td><button *ngIf="row.tiefe > 0" type="button" class="btn btn-outline-secondary btn-sm intermediate-plus" (click)="onAddHorizontZeile(i)"><bi name="plus"></bi><bi name="arrow-90deg-right"></bi></button></td>
								<td class="col-tiefe"><wd-number-input name="HTiefe[{{i}}]" [(model)]="row.tiefe" [hideComments]="true"></wd-number-input></td>
								<td class="col-maechtigkeit"><wd-number-input name="HMächtigkeit[{{i}}]({{row.tiefe}}cm)" [(model)]="row.maechtigkeit" [hideComments]="true"></wd-number-input></td>
								<td *ngFor="let col of row.horizonte; let j = index; trackBy: trackByIndex">
									<wd-typeahead name="Horizont{{j+1}}[{{i}}]({{row.tiefe}}cm)" [(model)]="row.horizonte[j]" [hideComments]="true"></wd-typeahead>
								</td>
								<td><button type="button" class="btn btn-danger btn-sm" (click)="onRemoveHorizontZeile(i)"><bi name="trash"></bi></button></td>
							</tr>
							<tr *ngIf="hasHorizontRowComments(i, row.tiefe)" wd-table-row-comments
								[rowIndex]="i" [tiefe]="row.tiefe" [fieldPrefixes]="horizontFieldPrefixes()" [colspan]="7" [fieldNameMap]="fieldNameMap">
							</tr>
						</ng-container>
						<tr>
							<td colspan="7">
								<button style="width: 100%" type="button" class="btn btn-info" (click)="onAddHorizontZeile()"><bi name="plus"></bi></button>
							</td>
						</tr>
					</tbody>
				</table>
		</div>
	</div>
	<table class="table table-sm table-striped bottom-table">
		<tbody>
			<tr>
				<th>Entwässerungsverhalten</th>
				<td><wd-list-input name="Entwässerungsverhalten" [(model)]="data.extendedHeader.entwaesserungsverhalten"></wd-list-input></td>
			</tr>
			<tr>
				<th>nWSK (bis 160cm)</th>
				<td class="calculated-cell"><span class="calculated-value">{{ schichtNWSKGesamt() }}</span></td>
			</tr>
			<tr>
				<th>Substratfeuchte</th>
				<td class="calculated-cell"><span class="calculated-value">{{ substratFeuchte() }}</span></td>
			</tr>
			<tr>
				<th>Bemerkungen</th>
				<td><wd-textarea name="Bemerkungen" [(model)]="data.header.bemerkungen" modalContainerSelector="bp-hl-area-container"></wd-textarea></td>
			</tr>
		</tbody>
	</table>
</bp-hl-area-container>
